import React from 'react';
import { site } from '../data/site';
export function Footer() {
  return <footer className="bg-brand-navy px-4 py-12 text-center text-sm text-white/60" data-id="element-77" data-mp="3gf94uw0pu68y">
      <div className="mx-auto max-w-[1120px]" data-id="element-78" data-mp="3gh3qkcjta2e3">
        <div className="mb-3 font-serif text-xl font-bold tracking-tight text-white" data-id="element-79" data-mp="32ovw4rg02nik">PHYSICAL EDUCATION READY</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-80" data-mp="36q93x72nl0s4">
          A complete, ready-to-use Physical Education teaching system for Elementary and Secondary teachers.
        </p>
        <nav aria-label="Legal" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-81" data-mp="37fvf8oqf24t">
          {site.legalLinks.map(({
          label,
          href
        }) => <a key={label} href={href} className="transition-colors hover:text-white" data-id="element-82" data-mp="3qcx86ace0m2q">
              {label}
            </a>)}
        </nav>
        <p className="text-xs" data-id="element-83" data-mp="2a19tpmiidoxa">© {site.year} Physical Education Ready. All rights reserved.</p>
        <p className="mx-auto mt-4 max-w-2xl text-[11px] leading-relaxed text-white/40" data-id="element-84" data-mp="2ezl4bzgmo3gk">
          Physical Education Ready is an independent educational resource. Teachers and schools are responsible for
          applying local curriculum requirements, safeguarding procedures, medical guidance, facility rules, and safety
          policies.
        </p>
      </div>
    </footer>;
}